import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Nav } from "@/components/landing/Nav";
import { Hero } from "@/components/landing/Hero";
import { Ticker } from "@/components/landing/Ticker";
import { MarketData } from "@/components/landing/MarketData";
import { Directory } from "@/components/landing/Directory";
import { Explainers } from "@/components/landing/Explainers";
import { NewsFeed } from "@/components/landing/NewsFeed";
import { Faq } from "@/components/landing/Faq";
import { EnquirySection } from "@/components/landing/EnquirySection";
import { Footer } from "@/components/landing/Footer";
import { Seo } from "@/components/Seo";
import DirectoryPage from "@/pages/DirectoryPage";
import ExplainersIndex from "@/pages/ExplainersIndex";
import ArticlePage from "@/pages/ArticlePage";
import MetricsPage from "@/pages/MetricsPage";

const LandingPage = () => (
  <div className="bg-navy text-ink min-h-screen antialiased" data-testid="landing-page">
    <Seo />
    <Nav />
    <Hero />
    <Ticker />
    <MarketData />
    <Directory />
    <Explainers />
    <NewsFeed />
    <Faq />
    <EnquirySection />
    <Footer />
  </div>
);

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollManager />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/directory" element={<DirectoryPage />} />
          <Route path="/explainers" element={<ExplainersIndex />} />
          <Route path="/explainers/:slug" element={<ArticlePage />} />
          <Route path="/metrics" element={<MetricsPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
